import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Section } from './ui/Section';
import { Icon } from './ui/Icon';

const Item = ({ item, open, onToggle, idx }) => (
  <div
    className="rounded-2xl border bg-surface overflow-hidden"
    style={{ borderColor: open ? 'var(--brand)' : 'var(--border)' }}
  >
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
    >
      <span className="flex items-start gap-3 min-w-0">
        <span className="text-mono text-xs text-subtle pt-1 shrink-0">
          {String(idx + 1).padStart(2, '0')}
        </span>
        <span className="text-app font-medium leading-snug">{item.q}</span>
      </span>
      <motion.span
        animate={{ rotate: open ? 45 : 0 }}
        transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
        className="inline-flex items-center justify-center h-8 w-8 rounded-full border shrink-0"
        style={{ borderColor: 'var(--border-strong)' }}
      >
        <Icon name="plus" size={14} />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="px-4 pb-4 pl-8 sm:pl-12 sm:px-5 sm:pb-5 text-sm text-muted leading-relaxed">
            {item.a}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const FAQ = () => {
  const { language } = useLanguage();
  const t = content[language];
  const [open, setOpen] = useState(0);

  return (
    <Section
      id="faq"
      eyebrow={t.faq.eyebrow}
      title={t.faq.title}
      align="center"
      className="bg-app"
    >
      <div className="max-w-3xl mx-auto grid gap-3">
        {t.faq.items.map((item, i) => (
          <Item
            key={i}
            item={item}
            idx={i}
            open={open === i}
            onToggle={() => setOpen(open === i ? -1 : i)}
          />
        ))}
      </div>
    </Section>
  );
};

export default FAQ;
